module.exports = __webpack_public_path__ + "img/moments2.8a34f5e3.png";